/**
 * 超级管理员仪表盘 - 参考 openlink.chat 设计风格
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const apiClient = axios.create({ baseURL: '/api' });

// 内联 SVG 图标
const Icons = {
  Users: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  MessageSquare: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
    </svg>
  ),
  Bot: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  MessageCircle: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
  ),
  LogOut: ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
  ),
  Search: ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  ChevronLeft: ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  ),
  ChevronRight: ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  ),
  Dashboard: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  ),
  Document: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  Key: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
    </svg>
  ),
  User: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Menu: ({ className = "w-6 h-6" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  ),
  X: ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
};

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<any>(null);
  const [detailItems, setDetailItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'users' | 'groups' | 'robots' | 'sessions'>('users');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<any>({ page: 1, limit: 10, total: 0, totalPages: 0 });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    if (!token) { navigate('/admin/login'); return; }
    loadStats();
    loadDetail('users');
  }, []);

  useEffect(() => {
    loadDetail(activeTab);
  }, [activeTab, page, search]);

  const api = (path: string, opts?: { params?: any }) =>
    apiClient.get(path, { headers: { Authorization: `Bearer ${token}` }, ...opts });

  async function loadStats() {
    try {
      const res = await api('/admin/stats');
      setStats(res.data.data);
    } catch { setStats(null); }
    finally { setLoading(false); }
  }

  async function loadDetail(tab: string) {
    setLoading(true);
    try {
      const params: any = { page, limit: 10 };
      if (search) params.search = search;
      const res = await api(`/admin/${tab}`, { params });
      if (res.data.success) {
        setDetailItems(res.data.data.items);
        setPagination(res.data.data.pagination);
      }
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }

  function handleSearch(e: React.FormEvent) {
    e.preventDefault();
    setPage(1);
    loadDetail(activeTab);
  }

  function logout() {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_expires');
    navigate('/admin/login');
  }

  const navItems = [
    { key: 'users' as const, label: '用户管理', icon: Icons.Users },
    { key: 'groups' as const, label: '群组管理', icon: Icons.MessageSquare },
    { key: 'robots' as const, label: '机器人管理', icon: Icons.Bot },
    { key: 'sessions' as const, label: '会话管理', icon: Icons.MessageCircle },
  ];

  if (loading && !stats) {
    return <div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lobster-red" /></div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 左侧固定导航栏 */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transition-transform duration-300 ease-in-out transform lg:translate-x-0 ${
          mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <img src="/logo.png" alt="Logo" className="w-[90px] h-auto" />
          </div>
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="lg:hidden p-1 rounded-md text-gray-400 hover:text-gray-600"
          >
            <Icons.X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex flex-col h-[calc(100vh-4rem)] overflow-y-auto">
          <nav className="flex-1 px-3 py-4 space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.key;
              return (
                <button
                  key={item.key}
                  onClick={() => { setActiveTab(item.key); setPage(1); setSearch(''); setMobileMenuOpen(false); }}
                  className={`w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${
                    isActive
                      ? 'bg-lobster-red/10 text-lobster-red'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <Icon className="w-5 h-5 mr-3" />
                  {item.label}
                </button>
              );
            })}
          </nav>

          <div className="p-4 border-t border-gray-200">
            <button
              onClick={logout}
              className="w-full flex items-center px-3 py-2 text-sm text-gray-700 rounded-lg hover:bg-red-50 hover:text-red-600 transition-colors"
            >
              <Icons.LogOut className="w-5 h-5 mr-3" />
              退出管理
            </button>
          </div>
        </div>
      </aside>

      {/* 移动端遮罩 */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-40 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* 主内容区 */}
      <div className="lg:pl-64">
        {/* 顶部栏（仅移动端） */}
        <div className="lg:hidden sticky top-0 z-30 bg-white border-b border-gray-200 px-4 h-16 flex items-center justify-between">
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="p-2 -ml-2 rounded-md text-gray-400 hover:text-gray-600"
          >
            <Icons.Menu className="w-6 h-6" />
          </button>
          <span className="font-bold text-gray-900">超级管理员</span>
          <div className="w-10" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* 页面标题 */}
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-900">
              {navItems.find(n => n.key === activeTab)?.label || '管理概览'}
            </h1>
            <p className="text-gray-500 mt-1">系统运行统计和数据总览</p>
          </div>

          {/* 统计卡片 */}
          {stats && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">注册账号</p>
                    <p className="text-3xl font-bold text-gray-900 mt-2">{stats.totalUsers}</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded-lg">
                    <Icons.Users className="w-8 h-8 text-blue-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">群组总量</p>
                    <p className="text-3xl font-bold text-gray-900 mt-2">{stats.totalGroups}</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded-lg">
                    <Icons.MessageSquare className="w-8 h-8 text-green-600" />
                  </div>
                </div>
                {stats.groupsByPlatform && stats.groupsByPlatform.length > 0 && (
                  <div className="mt-4 pt-3 border-t border-gray-100">
                    {stats.groupsByPlatform.map((p: any) => (
                      <div key={p.platform} className="flex items-center justify-between text-xs py-1">
                        <span className="text-gray-500">{p.platform}</span>
                        <span className="font-medium text-gray-700">{p.count}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">机器人总量</p>
                    <p className="text-3xl font-bold text-gray-900 mt-2">{stats.totalRobots}</p>
                  </div>
                  <div className="p-3 bg-purple-50 rounded-lg">
                    <Icons.Bot className="w-8 h-8 text-purple-600" />
                  </div>
                </div>
                <div className="mt-4 pt-3 border-t border-gray-100 space-y-1">
                  <div className="flex items-center justify-between text-xs">
                    <span className="flex items-center gap-1 text-green-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                      在线
                    </span>
                    <span className="font-medium text-gray-700">{stats.activeRobots}</span>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="flex items-center gap-1 text-amber-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                      待审批
                    </span>
                    <span className="font-medium text-gray-700">{stats.pendingRobots}</span>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">会话消息总量</p>
                    <p className="text-3xl font-bold text-gray-900 mt-2">{stats.totalMessages}</p>
                  </div>
                  <div className="p-3 bg-orange-50 rounded-lg">
                    <Icons.MessageCircle className="w-8 h-8 text-orange-600" />
                  </div>
                </div>
                <div className="mt-4 pt-3 border-t border-gray-100">
                  <div className="flex items-center justify-between text-xs">
                    <span className="flex items-center gap-1 text-blue-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                      活跃会话
                    </span>
                    <span className="font-medium text-gray-700">{stats.activeSessions}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 搜索 */}
          <form onSubmit={handleSearch} className="mb-4 flex gap-2">
            <div className="flex-1 relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2">
                <Icons.Search className="w-4 h-4 text-gray-400" />
              </div>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="搜索..."
                className="w-full pl-10 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-lobster-red"
              />
            </div>
            <button type="submit" className="px-4 py-2 bg-lobster-red text-white rounded-lg hover:bg-lobster-red/90 font-medium text-sm">
              搜索
            </button>
          </form>

          {/* 表格 */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {loading ? (
              <div className="p-8 text-center text-gray-500">加载中...</div>
            ) : renderTable()}
          </div>

          {/* 分页 */}
          {pagination.totalPages > 1 && (
            <div className="flex items-center justify-between mt-4">
              <span className="text-sm text-gray-500">共 {pagination.total} 条</span>
              <div className="flex gap-1">
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1}
                  className="p-2 rounded border border-gray-200 disabled:opacity-50 hover:bg-gray-100">
                  <Icons.ChevronLeft className="w-4 h-4" />
                </button>
                {Array.from({ length: Math.min(pagination.totalPages, 5) }, (_, i) => {
                  let p: number;
                  if (pagination.totalPages <= 5) p = i + 1;
                  else if (page <= 3) p = i + 1;
                  else if (page >= pagination.totalPages - 2) p = pagination.totalPages - 4 + i;
                  else p = page - 2 + i;
                  return (
                    <button key={p} onClick={() => setPage(p)}
                      className={`px-3 py-1 text-sm rounded border ${
                        page === p ? 'bg-lobster-red text-white border-lobster-red' : 'border-gray-200 hover:bg-gray-100'
                      }`}>
                      {p}
                    </button>
                  );
                })}
                <button onClick={() => setPage(p => Math.min(pagination.totalPages, p + 1))} disabled={page >= pagination.totalPages}
                  className="p-2 rounded border border-gray-200 disabled:opacity-50 hover:bg-gray-100">
                  <Icons.ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  function renderTable() {
    if (detailItems.length === 0) return <div className="p-8 text-center text-gray-500">暂无数据</div>;

    if (activeTab === 'users') {
      return (
        <table className="w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">邮箱</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">昵称</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">状态</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">注册时间</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-200">
            {detailItems.map((u: any) => (
              <tr key={u.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-mono text-xs">{u.email}</td>
                <td className="px-6 py-4">{u.nickname || '-'}</td>
                <td className="px-6 py-4"><StatusBadge status={u.status} /></td>
                <td className="px-6 py-4 text-gray-500">{new Date(u.created_at).toLocaleString('zh-CN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (activeTab === 'groups') {
      return (
        <table className="w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">群组名称</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Group ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">拥有者</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">机器人</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">平台</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">状态</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-200">
            {detailItems.map((g: any) => (
              <tr key={g.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-medium">{g.group_name}</td>
                <td className="px-6 py-4 font-mono text-xs">{g.group_id}</td>
                <td className="px-6 py-4">{g.owner_nickname || g.owner_email}</td>
                <td className="px-6 py-4">{g.robot_count}</td>
                <td className="px-6 py-4">{g.external_platform || '-'}</td>
                <td className="px-6 py-4"><StatusBadge status={g.status || 'active'} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (activeTab === 'robots') {
      return (
        <table className="w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">机器人名称</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">所属群组</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">状态</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">会话限制</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">最后活跃</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">加入时间</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-200">
            {detailItems.map((r: any) => (
              <tr key={r.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <div className="font-medium">{r.robot_name}</div>
                  <div className="font-mono text-xs text-gray-400">{r.robot_ak?.slice(0, 20)}...</div>
                </td>
                <td className="px-6 py-4">
                  <div>{r.group_name}</div>
                  <div className="font-mono text-xs text-gray-400">{r.group_id}</div>
                </td>
                <td className="px-6 py-4"><StatusBadge status={r.status} /></td>
                <td className="px-6 py-4">{r.session_limit === 0 ? '∞' : r.session_limit}</td>
                <td className="px-6 py-4 text-gray-500">{r.last_active ? new Date(r.last_active).toLocaleString('zh-CN') : '-'}</td>
                <td className="px-6 py-4 text-gray-500">{new Date(r.joined_at).toLocaleString('zh-CN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (activeTab === 'sessions') {
      return (
        <table className="w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Session Key</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">发送方</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">接收方</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">消息数</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">状态</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">最后活跃</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-200">
            {detailItems.map((s: any) => (
              <tr key={s.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-mono text-xs">{s.session_key?.slice(0, 30)}...</td>
                <td className="px-6 py-4">{s.sender_name || '-'}</td>
                <td className="px-6 py-4">{s.receiver_name || '-'}</td>
                <td className="px-6 py-4">{s.message_count}</td>
                <td className="px-6 py-4"><StatusBadge status={s.status} /></td>
                <td className="px-6 py-4 text-gray-500">{new Date(s.last_active_at).toLocaleString('zh-CN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return null;
  }
}

function StatusBadge({ status }: { status: string }) {
  const map: Record<string, string> = {
    active: 'bg-green-100 text-green-700',
    pending: 'bg-amber-100 text-amber-700',
    kicked: 'bg-red-100 text-red-700',
    disabled: 'bg-gray-100 text-gray-700',
    closed: 'bg-gray-100 text-gray-700',
  };
  return <span className={`px-2 py-0.5 rounded text-xs ${map[status] || map.active}`}>{status}</span>;
}
